import Swiper from 'swiper';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

class SwiperModule {
  constructor(container, options) {
    this.container = container;
    this.options = options;
    this.swiperInstance = null;

    this.initSwiper();
  }

  initSwiper() {
    this.swiperInstance = new Swiper(this.container, this.options);
  }

  updateSwiper() {
    // インスタンスのアップデートが必要な場合に呼び出すメソッド
    this.swiperInstance.update();
  }

  destroySwiper() {
    // インスタンスの破棄が必要な場合に呼び出すメソッド
    this.swiperInstance.destroy();
  }
}

export default SwiperModule;
